// extracted by mini-css-extract-plugin
export default {"wrapper":"cgWWhfli","mobile":"mobile","instagram-media":"instagram-media","leftSnippet":"trUgIn8f","rightSnippet":"Zyk8bSW7","divider":"TB12MhZd"};